module.exports = __webpack_public_path__ + "static/media/buy2.86d25b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/buy2.png
// module id = 409
// module chunks = 0